import { Unit } from '../../types';
import api from '../../utils/api';

export const createUnit = (variables: Unit) =>
  api.post({
    url: `/unit`,
    variables,
  });
